import { render, staticRenderFns } from "./OrchardMoment.vue?vue&type=template&id=3a84a0ee&scoped=true"
import script from "./OrchardMoment.vue?vue&type=script&lang=js"
export * from "./OrchardMoment.vue?vue&type=script&lang=js"
import style0 from "./OrchardMoment.vue?vue&type=style&index=0&id=3a84a0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84a0ee",
  null
  
)

export default component.exports